import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import officeWeekService from "./officeWeekService";

const initialState = {
  officeWeek: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//Edit student
export const getOfficeWeek = createAsyncThunk(
  "officeWeek/get",
  async (location_id, thunkAPI) => {
    try {
      const data = await officeWeekService.getOfficeWeek(location_id);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get user locations
export const postOfficeWeek = createAsyncThunk(
  "officeWeek/post",
  async (officeWeekData, thunkAPI) => {
    try {
      return await officeWeekService.postOfficeWeek(officeWeekData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const updateWeekStatus = createAsyncThunk(
  "officeWeek/update",
  async (week, thunkAPI) => {
    try {
      // console.log("in getOfficeWeek slice", location_id);

      return await officeWeekService.updateWeekStatus(week);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const officeWeekSlice = createSlice({
  name: "officeWeek",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(postOfficeWeek.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postOfficeWeek.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.officeWeek.push(action.payload);
      })
      .addCase(postOfficeWeek.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getOfficeWeek.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOfficeWeek.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.officeWeek = action.payload;
      })
      .addCase(getOfficeWeek.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      .addCase(updateWeekStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWeekStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.officeWeek = action.payload;
      })
      .addCase(updateWeekStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      });
  },
});

export const { reset } = officeWeekSlice.actions;
export default officeWeekSlice.reducer;
